(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const images = [...root.querySelectorAll('[data-quote-image]')];
    const thumbs = [...root.querySelectorAll('[data-quote-thumb]')];
    if (thumbs.length) {
      root.querySelector('[data-quote-thumbs]').hidden = false;
      images.forEach((image, i) => image.hidden = i !== 0);
      thumbs.forEach(button => button.addEventListener('click', () => {
        images.forEach(image => image.hidden = image.dataset.quoteImage !== button.dataset.quoteThumb);
        thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
      }));
    }
    // Reference values are millimeters, not an imperial conversion chart.
    const unit = root.querySelector('[name="contact[Diameter unit]"]');
    const diameter = root.querySelector('[name="contact[Diameter]"]');
    const list = diameter?.getAttribute('list');
    if (unit && list) unit.addEventListener('change', () => {
      if (unit.value === 'mm') diameter.setAttribute('list', list);
      else diameter.removeAttribute('list');
    });
    root.querySelectorAll('.rh-quote-description [style*="overflow-x"]').forEach(table => {
      table.tabIndex = 0;
      table.setAttribute('role', 'region');
      table.setAttribute('aria-label', 'Technical specifications, scroll horizontally for all columns');
    });
    // Native Shopify contact handling owns validation, submission and success.
    // Deliberately no fetch(), preventDefault(), simulated success or auto-submit.
  }
  document.querySelectorAll('[data-rh-quote]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rh-quote]').forEach(init));
})();
